import ApiService from "@/api.service";
import API from "@/API";

export const GET_LIST_PERMISSION = "listPermission";

export const SET_LIST_PERMISSION = "setListPermission";


const state = {
    permissions: []
};

const getters = {
    permissions(state) {
        return state.permissions;
    }
};

const actions = {
    [GET_LIST_PERMISSION](context) {
        return new Promise(resolve => {
            ApiService.query(API.GET_LIST_PERMISSION).then(({ data }) => {
                if (data.status) {
                    context.commit(SET_LIST_PERMISSION, data);
                }
                resolve(data);
            });
        });
    }
};

const mutations = {
    [SET_LIST_PERMISSION](state, data) {
        state.permissions = data.data;
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};